import { render, staticRenderFns } from "./WarrantyProduct.vue?vue&type=template&id=30080207&"
import script from "./WarrantyProduct.vue?vue&type=script&lang=js&"
export * from "./WarrantyProduct.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports